import { partnerSettingsStore, formatAmountToKilo, GameId } from '@bg-shared';
import classes from '../GameNavigationCard.module.scss';

interface IProps {
    gameId: GameId;
}

const formatCurrency = (amount: number) => formatAmountToKilo(amount, { formatToCurrency: true });

export const PLSBetLimits = (props: IProps) => {
    const betLimits = partnerSettingsStore.getBetLimits(props.gameId);

    if (!betLimits) {
        return null;
    }

    return (
        <div className={classes.limitsLabel} data-qa="text-game-menu-limits-label">
            {formatCurrency(betLimits.betMin)} - {formatCurrency(betLimits.betMax)}
        </div>
    );
};
